export enum PhaseItemCompletionStrategy {
  keepDates = 'KEEP_DATES',
  updateEndDate = 'UPDATE_END_DATE',
  updateDate = 'UPDATE_DATES',
}

export const COMPLETE_TYPES_OPTIONS = [
  {
    label: 'Keep Original Start/End Date',
    subLabel:
      'Keep the task’s original schedule, even though it’s overdue. Dependencies will remain intact, and no linked items will shift.',
    value: PhaseItemCompletionStrategy.keepDates,
  },
  {
    label: 'Specify End Date + Maintain Dependencies',
    subLabel:
      'Update only the end date for this task. All dependent items will adjust automatically according to the project’s dependency and lag rules',
    value: PhaseItemCompletionStrategy.updateEndDate,
  },
  {
    label: 'Specify Start/End Date + Unlink Dependencies',
    subLabel:
      'Manually set new start and end dates. Dependencies will be removed so changes won’t impact other linked tasks.',
    value: PhaseItemCompletionStrategy.updateDate,
  },
];
